function nasErrorEl() {
    return document.getElementById('pers_nas_error');
}

function showNasError(message) {
    const input = document.getElementById('pers_nas');
    const errorEl = nasErrorEl();
    if (!input) {
        return;
    }
    input.classList.add('is-invalid');
    input.setAttribute('aria-invalid', 'true');
    if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = message;
    }
}

function clearNasError() {
    const input = document.getElementById('pers_nas');
    const errorEl = nasErrorEl();
    if (input) {
        input.classList.remove('is-invalid');
        input.removeAttribute('aria-invalid');
        input.setCustomValidity('');
    }
    if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
    }
}

function nasIsMasked(value) {
    return value.includes('#') && /^[#\d]+$/.test(value);
}

function sanitizeNasInput(input) {
    const current = input.value;
    if (nasIsMasked(current)) {
        return current;
    }
    const digits = current.replace(/\D/g, '').slice(0, 9);
    if (digits !== current) {
        input.value = digits;
    }
    return digits;
}

function nasErrorMessage(input, kind) {
    const attr = kind === 'blank' ? 'nasBlank' : 'nasInvalid';
    return input.dataset[attr] || (kind === 'blank'
        ? 'Le NAS est obligatoire.'
        : 'Le NAS est invalide. Saisissez 9 chiffres (ex. 356897415).');
}

// Validation NAS sans bulle native (setCustomValidity/reportValidity bloquait tout le formulaire).
function add_nas_validation(options) {
    const opts = options || {};
    const requireValue = opts.requireValue === true;
    const nas_input = document.getElementById('pers_nas');
    if (nas_input == null) {
        return true;
    }

    nas_input.setCustomValidity('');
    const nas_input_value = sanitizeNasInput(nas_input);

    if (nasIsMasked(nas_input_value)) {
        clearNasError();
        return true;
    }

    if (nas_input_value.length === 0) {
        if (requireValue) {
            showNasError(nasErrorMessage(nas_input, 'blank'));
            return false;
        }
        clearNasError();
        return true;
    }

    if (validateSIN(nas_input_value)) {
        clearNasError();
        return true;
    }

    showNasError(nasErrorMessage(nas_input, 'invalid'));
    return false;
}

function add_ddn_validation() {
    const ddn_input = document.getElementById('pers_datenaiss');
    if (ddn_input == null) {
        return true;
    }
    const ddn_input_value = ddn_input.value;
    ddn_input.setCustomValidity('');

    if (!ddn_input_value || ddn_input_value.includes('#')) {
        return true;
    }
    if (validateDDN(ddn_input_value)) {
        ddn_input.value = ddn_input_value.replaceAll('/', '-');
        return true;
    }
    return false;
}

function validateDDN(ddn) {
  return /^\d{4}\-(0?[1-9]|1[012])\-(0?[1-9]|[12][0-9]|3[01])$/.test(ddn);
}

function validateSIN (sin) {
    let multiplyEveryOtherBy2 = (val, index) => val * ((index % 2) + 1);
    let sumValues = (acc, val) => acc + parseInt(val, 10);

    if (typeof sin === 'number') {
        sin = sin.toString();
    }

    sin = sin.trim();

    if (/\s+/.test(sin)) {
        return false;
    }

    if (!/^\d{9}$/.test(sin)) {
        return false;
    }

    sin = sin.split('');
    const check = parseInt(sin.pop(), 10);
    const total = sin
            .map(multiplyEveryOtherBy2)
            .join('').split('')
            .reduce(sumValues, 0);
    const expectedCheck = (10 - (total % 10)) % 10;
    return check === expectedCheck;
}

function phone_focus_out(){
    const phone = document.getElementById('[phones][Domicile][phone]');
    if (phone) {
        phone.setCustomValidity('');
    }
}

function email_focus_out(){
    const email = document.getElementById('email[Emai_EmailAddress]');
    if (email) {
        email.setCustomValidity('');
    }
}

function checkboxes_clicked(){
    checkboxes = document.querySelectorAll('.checkboxes');
    if(document.querySelectorAll('.checkboxes:checked').length>0) {
        checkboxes.forEach(function(checkbox){
            checkbox.removeAttribute('required');
        })
    } else {
        checkboxes.forEach(function(checkbox){
            checkbox.setAttribute('required', 'required');
        })
    }
}

nas_input = document.getElementById('pers_nas');
if(nas_input != null){
    nas_input.addEventListener('input', function (event) {
        if (nasIsMasked(event.target.value) && /\d/.test(event.data || '')) {
            event.target.value = (event.data || '').replace(/\D/g, '');
        }
        sanitizeNasInput(event.target);
        if (event.target.value.length === 0 || event.target.value.length === 9) {
            add_nas_validation({ requireValue: false });
        } else {
            clearNasError();
        }
    });
    nas_input.addEventListener('keydown', function (event) {
        if (event.ctrlKey || event.metaKey || event.altKey) {
            return;
        }
        const allowed = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'Enter'];
        if (allowed.indexOf(event.key) !== -1) {
            return;
        }
        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
        }
    });
    nas_input.addEventListener('paste', function (event) {
        event.preventDefault();
        const pasted = (event.clipboardData || window.clipboardData).getData('text') || '';
        const digits = pasted.replace(/\D/g, '').slice(0, 9);
        event.target.value = digits;
        add_nas_validation({ requireValue: false });
    });
    nas_input.addEventListener('focus', function (event) {
        if (nasIsMasked(event.target.value)) {
            event.target.select();
        }
    });
    nas_input.addEventListener('focusout', function () {
        add_nas_validation({ requireValue: false });
    });
}

ddn_input = document.getElementById('pers_datenaiss')
if(ddn_input != null){
    ddn_input.addEventListener( 'focusout', add_ddn_validation);
}

phone_input = document.getElementById('[phones][Domicile][phone]')
if(phone_input != null) {
    phone_input.addEventListener('focusout', phone_focus_out);
}

email_input = document.getElementById('email[Emai_EmailAddress]')
if(email_input != null) {
    email_input.addEventListener('focusout', email_focus_out);
}

checkboxes = document.querySelectorAll('div.new-employe-form form .checkboxes');
checkboxes.forEach(function(checkbox){
    checkbox.addEventListener('change', checkboxes_clicked);
});

function status_change() {
    const status = document.getElementById('pers_actif');
    const checkboxes = document.querySelectorAll('.checkboxes');
    if (!status) {
        return;
    }
    const isActive = status.value === 'Y';
    if (!isActive) {
        checkboxes.forEach(function (checkbox) {
            checkbox.removeAttribute('required');
            checkbox.removeEventListener('change', checkboxes_clicked);
        })
    } else {
        checkboxes.forEach(function (checkbox) {
            checkbox.setAttribute('required', 'required');
            checkbox.addEventListener('change', checkboxes_clicked);
        })
        checkboxes_clicked();
    }

    const endDate = document.getElementById('emem_finemploi');
    if (endDate && status.value === 'N' && !endDate.value) {
        const today = new Date().toISOString().slice(0, 10);
        endDate.value = today;
    }
    if (endDate && status.value === 'Y') {
        // Réactivation : l'utilisateur peut vider manuellement; on n'efface pas
        // automatiquement ici pour éviter une surprise à l'édition.
    }
}

if(document.getElementById('employe-form') != null){
    status_change();
    const statusInput = document.getElementById('pers_actif');
    if (statusInput) {
        statusInput.addEventListener('change', status_change);
    }
    document.getElementById('employe-form').addEventListener('submit', function(event) {
        add_ddn_validation();
        const nasValid = add_nas_validation({ requireValue: true });
        if (!nasValid) {
            event.preventDefault();
            const nasField = document.getElementById('pers_nas');
            if (nasField) {
                nasField.focus();
            }
        }
    });
}

function input_changed() {
    window.onbeforeunload = function (event) {
        return "Vous avez des modifications non sauvegardé";
    }
}
function page_changed() {
    max_page = document.querySelector("div.pagination input#max_page").value;
    form = document.querySelector("div.search form");
    input = document.querySelector("div.search form input#page");
    new_page = this.value;
    input.value = new_page >= max_page ? max_page : new_page;
    form.submit();
}
function per_page_changed() {
    form = document.querySelector("div.search form");
    input = document.querySelector("div.search form input#per_page")
    input.value = this.value;
    page_input = document.querySelector("div.search form input#page")
    page_input.value = 1;
    form.submit();
}

function batch_delete(event, url){
    event.preventDefault();
    event.stopPropagation();

    checked = document.querySelectorAll('input[name="employe_id"]:checked');
    ids = Array.from(checked).map(c => c.value).join(', ');
    if (!ids) {
        return;
    }

    const confirmMessage = event.currentTarget && event.currentTarget.dataset
        ? event.currentTarget.dataset.confirmMessage
        : null;
    if (confirmMessage && !window.confirm(confirmMessage)) {
        return;
    }

    const separator = url.indexOf('?') >= 0 ? '&' : '?';
    window.location = url + separator + 'ids=' + encodeURIComponent(ids);
}

function check_all(){
    checkboxes = document.querySelectorAll('input[name="employe_id"]');
    checkboxes.forEach( ckeckbox => {
        ckeckbox.checked = this.checked;
    });
}

inputs = document.querySelectorAll("div#employe div.edit-employe-form #employe-form input")
inputs.forEach( input => {
    input.addEventListener('change', input_changed);
});

document.querySelectorAll("select.per_page").forEach( function(input) {
    input.addEventListener('change', per_page_changed);
});

document.querySelectorAll("input#page_box").forEach( function(input) {
    input.addEventListener('change', page_changed);
});

document.querySelectorAll("a.delete").forEach( function(link) {
    link.addEventListener('click', (event) => batch_delete(event, link.href));
});

document.querySelectorAll("input#delete_all").forEach( function (input){
   input.addEventListener('click',  check_all);
});